<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-12">
          <h4 class="page-title content__title text-danger pointer" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>
            RESERVAS ABIERTAS (Pendientes de asignar fechas)</h4>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Exportar
              </button>
              <div class="dropdown-menu">
                <a target="_blank" href="/{{branchofficeSlug}}/api/bookings/tours/status_open/export/excel"
                  class="dropdown-item" href="#"><i class="far fa-file-excel text-success m-r-5"></i>Formato
                  Excel</a>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Responsable</th>
                  <th><span class="f-s-12">Etq./Grupo</span></th>
                  <th>Nombre Tours</th>
                  <th class="text-center">N° PAX</th>
                  <th>Hotel / Ubicacion</th>
                  <th>Teléfonos</th>
                  <th>Observaciones</th>
                  <th>Deuda</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <tr>
                    <td colspan="7"><span><i class="m-r-5"></i>Debe seleccionar el tours para cargar los
                        pasajeros de la reservas pendientes.</span>
                    </td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a class="m-b-2 d-block nowrap" (click)="detailBookingExtends(item)" data-toggle="modal"
                        data-target="#openBookingsExtends">
                        <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                        <span class="f-s-11 bold pointer book__code nowrap">{{item.code}}</span>
                      </a>
                    </td>
                    <td>
                      {{item.client}}
                      <p class="f-s-12 bold m-b-0" *ngIf="item.is_received"><span
                          class="badge badge-success">Recibido</span> |
                        {{item.agency_reponsible}}
                      </p>
                    </td>
                    <td>{{item.reference_voucher}}</td>
                    <td><span class="bold">{{item.tours_description}}</span></td>
                    <td class="text-center">
                      {{item.quantity}}
                    </td>
                    <td>{{item.reference_location}}</td>
                    <td>
                      <div>{{item.tel_1}}</div>
                      <div *ngIf="item.tel_2 != null">
                        {{item.tel_2}}
                      </div>
                    </td>
                    <td>
                      {{item.observations}}
                      <div *ngIf="item.observation != null">
                        | <span class="bold">{{item.observation}}</span>
                      </div>
                    </td>
                    <td>{{item.total - item.total_paid | currency:'S/ '}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bookings-extends (onSubmitEvent)="afterBookingDetail($event)"></app-bookings-extends>
